import React, { useEffect } from 'react';
import * as echarts from 'echarts';
import { AssetPortfolioComponentData } from '../type/AssetPortfolio.type';

export interface AssetPortfolioCardPieChart {
  assetPortfolioComponentDataList: AssetPortfolioComponentData[];
}

const AssetPortfolioCardPieChart = ({ assetPortfolioComponentDataList }: AssetPortfolioCardPieChart) => {
  useEffect(() => {
    const portfolioChartDom = document.getElementById('portfolio-chart');
    if (portfolioChartDom) {
      const portfolioChart = echarts.init(portfolioChartDom);
      const portfolioOption = {
        animation: false,
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
        },
        series: [
          {
            name: '현재 포트폴리오',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: assetPortfolioComponentDataList.map((assetPortfolioComponentData) => ({
              name: assetPortfolioComponentData.name,
              value: Math.round(assetPortfolioComponentData.actualRate * 10) / 10,
            })),
          },
        ],
      };
      portfolioChart.setOption(portfolioOption);
      window.addEventListener('resize', () => {
        portfolioChart.resize();
      });
    }
  }, [assetPortfolioComponentDataList]);
  return <div id="portfolio-chart" className="w-full h-64"></div>;
};

export default AssetPortfolioCardPieChart;
